import React from 'react';
import corporateSettings from 'utils/corporateSettings.json';

function DocumentSupportChannels({ partner }) {
  const partnerSettings = corporateSettings.find(({ id_partner }) => Number(id_partner) === Number(partner?.id));
  const additionalChannels = partnerSettings?.document_support_channels || [];

  return (
    <>
      <b>Canais de Atendimento</b>
      <h4>SAC: {partner?.phone_sac}</h4>
      {!partnerSettings?.hide_email_on_documents && <h4>Email: {partner?.email}</h4>}
      <h4>Assistência 24h: {partner?.phone_support}</h4>
      {additionalChannels.map(({ label, value, href }) => (
        <h4 key={label}>
          {label}:{' '}
          {href ? (
            <a href={href} target="_blank" rel="noreferrer">
              {value}
            </a>
          ) : (
            value
          )}
        </h4>
      ))}
    </>
  );
}

export default DocumentSupportChannels;
